import { render, staticRenderFns } from "./ManualTransactionLimits.vue?vue&type=template&id=00c9e4e6&scoped=true&"
import script from "./ManualTransactionLimits.vue?vue&type=script&lang=js&"
export * from "./ManualTransactionLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c9e4e6",
  null
  
)

export default component.exports